import { useLocation } from "react-router-dom";

const useCustomLocation = () => {
    const location = useLocation();
    const pathName = location.pathname;
    return {
        location,
        pathName,
        isTelaRegistraVenda: () => {
            return pathName === '/registra-venda';
        },
        isTelaPagamento: () => {
            return pathName === '/pagamento';
        },
        isTelaVenda: () => {
            return pathName === '/venda';
        },
        isTelaConfiguracoes: () => {
            return pathName === '/configuracoes';
        },
        isTelaCaixa: () => {
            return pathName === '/caixa';
        },
        isTelaValePresente: () => {
            return pathName === '/vale-presente';
        },
        isTelaBuscaAvancadaValePresente: () => {
            return pathName === '/vale-presente/busca-avancada';
        },
        isTelaRelatorioFechamentoCaixa: () => {
            return pathName === "/relatorio/caixa/fechamento";
        },
        isTelaPreVenda: () => {
            return pathName === "/pre-venda";
        },
        isTelaRegistraConsignado: () => {
            return pathName === "/registra-consignado";
        },
        isTelaConsignado: () => {
            return pathName === "/consignado";
        },
        isTelaDevolucaoConsignado: () => {
            return pathName === "/devolucao-consignado";
        },
        isTelaConferencia: () => {
            return pathName.startsWith("/conferencia");
        },
        isTelaFinancas: () => {
            return pathName === "/financas"
        },
        isTelaFinancasGestaoReceber: () => {
            return pathName === "/financas/gestao-receber"
        }
    };
};

export default useCustomLocation;
